import { atcb_init } from 'add-to-calendar-button';

const directive = {
  inserted() {
    atcb_init();
  },
};

export default directive;
